import React, { Component } from 'react'
import { vuMainUnitLink } from '../../../helpers/links'
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material'

class ChoiceLineAllSelections extends Component {
  constructor(props) {
    super(props)
  }

  handleChoiceLineSelection = (choiceLineSelect, selected = false, event) => {
    this.props.handleChoiceLineSelection(choiceLineSelect, selected, event)
  }

  renderSelectionPointsColumnName = () => {
    if (this.props.choiceLine.rule.structureRuleCode === '$CP') {
      return 'Credit Points'
    } else if (this.props.choiceLine.rule.structureRuleCode === '$NOC') {
      return 'Item(s)'
    }
  }

  renderMainUnitLink = (choiceLineSelection, title) => {
    if (this.props.choiceLine.rule.structureSelection) {
      return null;
    }

    return (
      <span>
        {' '}{vuMainUnitLink(choiceLineSelection.studyPackageCode, title)}
      </span>
    )
  }

  renderDivSelections = () => {
    return this.props.choiceLine.selections.map((choiceLineSelection, index) => {
      let canWithdraw = this.props.availableSelections.length === 0
      if (!canWithdraw) {
        canWithdraw = this.props.availableSelections.some(selections => selections.rules.some(rule => rule.structureListId === choiceLineSelection.structureListId))
      }

      if (canWithdraw && choiceLineSelection.studentStudyPackageAttempt >= 1) {
        canWithdraw = choiceLineSelection.canModify
      }

      let title = choiceLineSelection.canWithdraw
        ? 'You can’t change this selection because you are currently enrolled in this unit. Please withdraw from the unit and then try again, or contact your Course and Unit Advisor to discuss changing this selection.'
        : 'You can’t change this selection in MyVU. Please contact your Course and Unit Advisor to discuss changing this selection.'

      return (
        <div className={'choiceLineSelectionsRow'} key={`${choiceLineSelection.studyPackageCode}_${choiceLineSelection.studyPackageNumber}`}>
          <FormGroup>
            <FormControlLabel 
              label={(
                <div>
                  <label htmlFor={`${choiceLineSelection.structureId}_${choiceLineSelection.structureListId}_${choiceLineSelection.studyPackageCode}_${choiceLineSelection.studyPackageNumber}`}>
                  {choiceLineSelection.studyPackageFullTitle}  | {choiceLineSelection.studyPackageCode} | {choiceLineSelection.credit} {this.renderSelectionPointsColumnName()}
                  </label>
                </div>
              )}
              control={
                <Checkbox
                  id={`${choiceLineSelection.structureId}_${choiceLineSelection.structureListId}_${choiceLineSelection.studyPackageCode}_${choiceLineSelection.studyPackageNumber}`}
                  className="choiceLinesCheckbox"
                  disabled={!canWithdraw}
                  title={choiceLineSelection.studentStudyPackageAttempt === 1 && !choiceLineSelection.canModify ? title : null}
                  
                  onChange={(event, isInputChecked) => this.handleChoiceLineSelection(choiceLineSelection, !isInputChecked, event)}
                  checked={this.props.selectedUnits && this.props.selectedUnits.some(choiceLine => choiceLine.studyPackageNumber === choiceLineSelection.studyPackageNumber)}
                />
              }
            />
          </FormGroup>
        </div>
      )
    })
  }

  render() {
    return (
      <div id={this.props.choiceLine.rule.structureListId} className='modal-mb-10 selection-group-choiceline'>
        <div className={'choiceLineSelectionsHeading'}>
          <h3>{this.props.choiceLine.rule.structureListName}</h3>
        </div>
        <div className={'choiceLineSelections'}>{this.renderDivSelections()}</div>
      </div>
    )
  }
}

export default ChoiceLineAllSelections
